import { Card, CardContent, Grid, Typography } from '@mui/material';

import { Link } from 'react-router-dom';

import PageTitle from 'components/PageTitle/PageTitle';

import {
	testHubImage,
	testPlanEllipse,
	testAreaEllipse,
	testsEllipse,
} from 'common/assets/images';
import Breadcrumbs from 'common/components/Breadcrumbs/Breadcrumbs';
import ButtonComp from 'common/components/Button/ButtonComp';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import { TestHubText } from 'common/constants/TextContent';
import { ImgTagComponent, urlWithTenant } from 'common/utils/utilFunctions';

import commonStyles from 'features/common/Common.module.scss';

import styles from './TestHubLandingPage.module.scss';

const TestHubLandingPage = () => {
	const breadcrumbs = [
		<Link key="1" to={urlWithTenant(`/${rrcpDashboardRoutes.testing}`)}>
			Testing & monitoring
		</Link>,
		<Typography key="2">Test hub</Typography>,
	];
	return (
		<Grid container>
			<Grid item>
				<PageTitle text={TestHubText} />
				<Breadcrumbs breadcrumbs={breadcrumbs} />
			</Grid>
			<Grid item className={styles['landing-cards-style']}>
				<div
					className={`${commonStyles['main-tabs-box']} 
						}`}
				>
					<Grid
						container
						spacing={2}
						className={`${commonStyles['landing-grid-style']} ${styles['testhub-grid-style']}`}
					>
						<Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
							<Card
								className={`${commonStyles['landing-card-style']} ${styles['testhub-card-style']}`}
							>
								<CardContent
									className={commonStyles['landing-card-content-style']}
								>
									<Typography className={styles['testhub-card-header']}>
										Test plans
									</Typography>
									<div className={styles['test-hub-graphstyle']}>
										{ImgTagComponent(testHubImage, 'Test Plan')}
										{ImgTagComponent(
											testPlanEllipse,
											'Test Plan Ellipse',
											styles['plan-image-style'],
										)}
									</div>
									<ButtonComp
										btnType="secondary"
										compClass={styles['landing-view-button-style']}
										disabled={false}
									>
										View existing test plans
									</ButtonComp>
									<ButtonComp
										btnType="primary"
										compClass={styles['landing-button-style']}
										data-testid="login-button"
									>
										Create new test plans
									</ButtonComp>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
							<Card
								className={`${commonStyles['landing-card-style']} ${styles['testhub-card-style']}`}
							>
								<CardContent
									className={commonStyles['landing-card-content-style']}
								>
									<Typography className={styles['testhub-card-header']}>
										Test areas
									</Typography>
									<div className={styles['test-hub-graphstyle']}>
										{ImgTagComponent(testHubImage, 'TestAreas')}
										{ImgTagComponent(
											testAreaEllipse,
											'Test Area Ellipse',
											styles['area-image-style'],
										)}
									</div>
									<ButtonComp
										btnType="secondary"
										compClass={styles['landing-view-button-style']}
										disabled={false}
									>
										View existing test areas
									</ButtonComp>
									<ButtonComp
										btnType="primary"
										compClass={styles['landing-button-style']}
										data-testid="login-button"
									>
										Create new test areas
									</ButtonComp>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
							<Card
								className={`${commonStyles['landing-card-style']} ${styles['testhub-card-style']}`}
							>
								<CardContent
									className={commonStyles['landing-card-content-style']}
								>
									<Typography className={styles['testhub-card-header']}>
										Tests
									</Typography>
									<div className={styles['test-hub-graphstyle']}>
										{ImgTagComponent(testHubImage, 'Tests')}
										{ImgTagComponent(
											testsEllipse,
											'Tests Ellipse',
											styles['test-image-style'],
										)}
									</div>
									<ButtonComp
										btnType="secondary"
										compClass={styles['landing-view-button-style']}
										disabled={false}
									>
										View existing tests
									</ButtonComp>
									<ButtonComp
										btnType="primary"
										compClass={styles['landing-button-style']}
									>
										Create new tests
									</ButtonComp>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</div>
			</Grid>
		</Grid>
	);
};

export default TestHubLandingPage;
